<div class="container-capped-sm py-3">
  <app-payment-check #paymentCheck *ngIf="payment" (closed)="completed()">
    <ng-template #success>
      <p>سرویس «{{payment.Description||'مورد درخواست'}}» برای کاربر
        «{{name}} به شماره همراه <span dir="ltr">{{mobile}}</span>»
        به مدت {{payment.Item.month}} ماه فعال شد.</p>
    </ng-template>
  </app-payment-check>

  <div *ngIf="payment" [ngSwitch]="isMe">
    <ng-container *ngIf="payment.Status==PaymentStatus.Pending || payment.Status==PaymentStatus.Link">
      <h5>پرداخت و فعالسازی سرویس «{{payment.Description}}»</h5>

      <ng-container *ngSwitchCase="false">
        <div class="kp-message kp-message-info">
          این صفحه به درخواست
          <span class="fw-bold">«{{name}}»</span>
          برای پرداخت و فعالسازی سرویس فوق ایجاد شده است.<br />
          با تکمیل این پرداخت این خدمات فعال خواهد شد.<br />
          لطفا در صورتی که این اطلاعات مورد تایید شما می‌باشد، بر روی دکمه‌ی «پرداخت و فعالسازی» کلیک کنید.
        </div>
        <div class="kp-message ">
          <div class="d-flex justify-content-between align-items-center">
            <div>درخواست دهنده:</div>
            <div>{{name}}</div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div>شماره همراه:</div>
            <div class="ltr">{{mobile}}</div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div>مبلغ قابل پرداخت:</div>
            <div>{{payment.Amount | number}} تومان</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="true">
        <div class="kp-message kp-message-info">
          <h6>یادآوری پرداخت جهت فعالسازی خدمات مورد تقاضا</h6>
          در صورتی که هنوز سرویس را فعال نکردی روی دکمه «پرداخت و فعالسازی» کلیک کن
        </div>
        <div class="kp-message ">
          <div class="d-flex justify-content-between align-items-center">
            <div>مبلغ قابل پرداخت:</div>
            <div>{{payment.Amount | number}} تومان</div>
          </div>
        </div>
      </ng-container>

      <button class="btn btn-primary w-100" (click)="paymentModal.open()">پرداخت و فعالسازی</button>
    </ng-container>

    <ngx-smart-modal #paymentModal identifier="paymentModal">
      <div class="d-flex flex-column container-capped-sm f-initial text-right py-2">
        <div class="border-bottom mb-3">
          <!-- <div class="text-center green-bg f-white fw-bold fs-lg">پرداخت شما ضمانت بازگشت وجه دارد!</div> -->
          <h5 class="kp-title-line mb-2">
            یک روش رو از زیر انتخاب کن
          </h5>
        </div>
        <div class="mb-2 pb-2 border-bottom pointer" (click)="pay()">
          <div class="h6">پرداخت از طریق درگاه اینترنتی</div>
          <div class="f-gray">توجه: نیاز به رمز دوم یا رمز پویا دارد.</div>
          <div class="text-left ">
            <button class="btn btn-primary my-2 flex-column">پرداخت آنلاین </button>
          </div>
        </div>
        <div class="mb-2 pb-2 pointer" (click)="manualModal.open()">
          <div class="h6">پرداخت از طریق کارت به کارت</div>
          <div class="f-gray">از طریق <b>دستگاه خودپرداز(ATM)</b> یا نرم‌افزارهای انتفال وجه مانند
            <b>آپ و همراه کارت و ...</b>
          </div>
          <div class="text-left ">
            <button class="btn btn-primary my-2 flex-column">پرداخت کارت به کارت </button>
          </div>
        </div>
      </div>
    </ngx-smart-modal>
    <app-manual-payment-modal #manualModal [amount]="payment.Amount"
      (submitPayment)="pay($event)"></app-manual-payment-modal>
  </div>
</div>